import React from "react";
import { useState, useEffect } from "react";
import "../assets/css/video_youtube.css";
import axios from "axios";

const todaysDate = new Date();
// const apiUrl = "https://aed.mju.ac.th/API/arch/youtube/";
const apiUrl = process.env.REACT_APP_API_URL;

function showUntilChecker(imgUntil) {
    const imgDate = new Date(imgUntil);
    if (imgDate >= todaysDate) {
        return true;
    } else {
        return false;
    }
}

export default function YoutubeEmbed() {
    const [videoData, setVideoData] = useState([]);
    // const apiUrl = apiUrl+"index.json";

    

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await axios.get(`${apiUrl}youtube/index.json`);
                // const result = await axios.get(apiUrl);
                setVideoData(result.data[0]);
                //   setIsloading(false);
                // console.info("json:", result.data[0]);
            } catch (e) {
                console.error("fetch ERROR: ", e);
                //   setIsloading(true);
            }
        };

        fetchData();
        // console.log("datails: ", videoData);
        // eslint-disable-next-line
    }, []);

    if (showUntilChecker(videoData.untilDate)) {
    return (
        <div className="container my-5 video-responsive">
            <iframe
                width={videoData.width}
                height={videoData.height}
                src={`https://www.youtube.com/embed/${videoData.embedId}`}
                // frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={videoData.title}
                className="shadow"
            />
        </div>
    );
    }
}
